/**
 * List of all possible environnement
 * An environnement is a sub domain name
 */
const envList = {
  CA: {
    path: 'combles_amenage',
    first: 'projet',
  },
  IME: {
    path: 'iso_mur_ext',
    first: 'projet',
  },
  CP: {
    path: 'combles_perdus',
    first: 'projet',
  },
  /**
   * check if the env is the same as a CA env
   * @param {string} env the environement to test
   * @return {boolean}
   */
  isCA: env => envList.CA.path === env,
  isCP: env => envList.CP.path === env,
};

/**
 * return the name of the first page for an environement
 * @param {string} envToFound the path of the concerned environement present in the envList
 * @returns {string} the name of the first page
 */
const getFirstPage = (envToFound) => {
  const envFounded = Object.values(envList).find(env => env.path === envToFound);
  if (envFounded) return envFounded.first;
  return '';
};

export default envList;
export { getFirstPage };



// WEBPACK FOOTER //
// ./src/constants/envList.js